module.exports = __webpack_public_path__ + "static/media/Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL.21512135.jpg";